import { z } from 'zod';

export const DatabaseFeatureFlagKeys = ['topLevelAnalysisOnDeploy'] as const;

export const DatabaseFeatureFlagKey = z.enum(DatabaseFeatureFlagKeys);
export type DatabaseFeatureFlagKey = z.infer<typeof DatabaseFeatureFlagKey>;

export const DatabaseFeatureFlags = z.object({
  topLevelAnalysisOnDeploy: z.boolean().optional(),
});

export type DatabaseFeatureFlags = z.infer<typeof DatabaseFeatureFlags>;

export const DatabaseFeatureFlagDetailsDto = z.object({
  enabled: z.boolean(),
  updatedAt: z.coerce.date(),
});

export type DatabaseFeatureFlagDetailsDto = z.infer<
  typeof DatabaseFeatureFlagDetailsDto
>;

export const DatabaseFeatureFlagsResponseDto = z.object({
  topLevelAnalysisOnDeploy: DatabaseFeatureFlagDetailsDto.optional(),
});

export type DatabaseFeatureFlagsResponseDto = z.infer<
  typeof DatabaseFeatureFlagsResponseDto
>;

export const UpdateDatabaseFeatureFlagsDto = z.object({
  topLevelAnalysisOnDeploy: z.boolean().optional(),
});

export type UpdateDatabaseFeatureFlagsDto = z.infer<
  typeof UpdateDatabaseFeatureFlagsDto
>;
